import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FlexColumn } from '@elementary/common-ui/components';
import RuleAccordion, {
  RuleAccordionProps,
  RuleReorderProps,
} from './RuleAccordion';

const SortableItem = styled(FlexColumn)<{ $isDragging: boolean }>`
  position: relative;
  z-index: ${({ $isDragging }) => ($isDragging ? 1 : 'auto')};
  opacity: ${({ $isDragging }) => ($isDragging ? 0.8 : 1)};
`;

type Props = RuleAccordionProps &
  Pick<RuleReorderProps, 'onMoveUp' | 'onMoveDown'> & {
    disabled?: boolean;
  };

const SortableRuleAccordion = ({ disabled, ...props }: Props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.id, disabled });

  return (
    <SortableItem
      ref={setNodeRef}
      $isDragging={isDragging}
      sx={{ transform: CSS.Translate.toString(transform), transition }}
    >
      <RuleAccordion
        {...props}
        dragHandle={{ attributes, listeners, setActivatorNodeRef }}
        isDragging={isDragging}
      />
    </SortableItem>
  );
};

export default SortableRuleAccordion;
